import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Popover, Typography } from 'gu-ui-kit'
import styles from './info-popover.module.scss'
import { format, parse } from 'date-fns'
import { StatusBadge } from 'modules/Services/CampaignsEditor/subcomponents/StatusBadge'
import { useTranslation } from 'react-i18next'
import { formatByLocale } from 'utils/formatMoney'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const InfoPopover = ({
  short = false,
  popoverState,
  bindPopover,
  data: {
    status,
    external_id,
    date_end,
    name,
    agency_client_name,
    date_start,
    budget_limit,
    budget_limit_day,
    created,
    updated,
  },
  resource,
}) => {
  const { t } = useTranslation()
  const yesterday = new Date().setDate(new Date().getDate() - 1)
  const dateEnd = parse(date_end, 'yyyy-MM-dd', new Date()).getTime()
  const { fb } = useBreakpoint()

  return (
    <Popover
      {...bindPopover(popoverState)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 8,
        horizontal: 'left',
      }}
      bodyClassName={styles['popover']}
    >
      <Grid
        gap={32}
        onMouseEnter={() => {
          if (fb) return
          popoverState.lock()
        }}
        onMouseLeave={() => {
          if (fb) return
          popoverState.lock()
          popoverState.close()
        }}
      >
        <Grid gap={12} direction={'column'}>
          <Grid
            flexJustify={'space-between'}
            wrap={false}
            alignItems={'center'}
          >
            <StatusBadge
              resource={resource}
              status={status}
              dateEndReached={dateEnd <= yesterday}
            />
            <Typography variant={'Body-15'} color={'Label-Secondary'} noWrap>
              {t('campaigns_editor::info-popover.external_id')}
              {': '}
              {external_id}
            </Typography>
          </Grid>
          <Typography variant={'Subtitle-20'} color={'Label-Fifth'}>
            {name}
          </Typography>
        </Grid>
        <table className={styles['table']}>
          <tbody>
            {agency_client_name && (
              <tr>
                <Typography
                  variant={'Body-15'}
                  component={'td'}
                  color={'Label-Secondary'}
                >
                  {t('campaigns_editor::info-popover.account')}
                </Typography>

                <Typography variant={'Body-Forms-15'} component={'td'}>
                  {agency_client_name}
                </Typography>
              </tr>
            )}
            {!short && (
              <>
                <tr>
                  <Typography
                    variant={'Body-15'}
                    component={'td'}
                    color={'Label-Secondary'}
                  >
                    {t('campaigns_editor::info-popover.dates')}
                  </Typography>
                  <Typography variant={'Body-Forms-15'} component={'td'}>
                    {format(
                      parse(date_start, 'yyyy-MM-dd', new Date()),
                      'dd.MM',
                    )}
                    {date_end &&
                      ' — ' +
                        format(
                          parse(date_end, 'yyyy-MM-dd', new Date()),
                          'dd.MM',
                        )}
                  </Typography>
                </tr>
                <tr>
                  <Typography
                    variant={'Body-15'}
                    component={'td'}
                    color={'Label-Secondary'}
                  >
                    {t('campaigns_editor::info-popover.budget')}
                  </Typography>
                  <Typography variant={'Body-Forms-15'} component={'td'}>
                    {budget_limit ? (
                      <>
                        <span>{formatByLocale(budget_limit, '')}</span>{' '}
                        {t(
                          'campaigns_editor::info-popover.budget_labels.limit',
                        )}
                      </>
                    ) : budget_limit_day ? (
                      <>
                        <span>{formatByLocale(budget_limit_day, '')}</span>{' '}
                        {t(
                          'campaigns_editor::info-popover.budget_labels.limit_day',
                        )}
                      </>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t(
                            'campaigns_editor::info-popover.budget_labels.unlimited',
                            {
                              context: resource,
                            },
                          ),
                        }}
                      />
                    )}
                  </Typography>
                </tr>
              </>
            )}
            <tr>
              <Typography
                variant={'Body-15'}
                component={'td'}
                color={'Label-Secondary'}
              >
                {t('campaigns_editor::info-popover.created')}
              </Typography>
              <Typography variant={'Body-Forms-15'} component={'td'}>
                {created}
              </Typography>
            </tr>
            <tr>
              <Typography
                variant={'Body-15'}
                component={'td'}
                color={'Label-Secondary'}
              >
                {t('campaigns_editor::info-popover.updated')}
              </Typography>
              <Typography variant={'Body-Forms-15'} component={'td'}>
                {updated}
              </Typography>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Popover>
  )
}

InfoPopover.propTypes = {
  popoverState: PropTypes.object,
  bindPopover: PropTypes.function,
  data: PropTypes.object,
  resource: PropTypes.string,
  short: PropTypes.bool,
}

export default InfoPopover
